import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navigation from "./components/Navigation";
import ProtectedRoute from "./components/ProtectedRoute";
import DailyQuestionnaire from "./components/DailyQuestionnaire";
import GoalsList from "./components/GoalsList";
import GoalHistory from "./components/GoalHistory";
import CalendarView from "./components/CalendarView";
import Login from "./authComponents/Login";
import Signup from "./authComponents/Signup";
import PasswordReset from "./authComponents/PasswordReset";
import "./App.css";

const App: React.FC = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/password-reset" element={<PasswordReset />} />
        <Route path="/reset-password" element={<PasswordReset />} />
        <Route
          path="/*"
          element={
            <ProtectedRoute>
              <Navigation />
              <main className="main-content">
                <Routes>
                  <Route path="/" element={<DailyQuestionnaire />} />
                  <Route path="/goals" element={<GoalsList />} />
                  <Route path="/goals/:goalId/history" element={<GoalHistory />} />
                  <Route path="/calendar" element={<CalendarView />} />
                </Routes>
              </main>
            </ProtectedRoute>
          }
        />
      </Routes>
    </BrowserRouter>
  );
};

export default App;
